import React from 'react';
import { ValidationProps } from 'ui';
import { equalsIgnoringWhitespace } from 'app/infrastructure/data/string';
import { TextConfigurationTranslation } from '../../../constants';
import { getModifiedText } from '../selectors';
import { getComponentValidation } from '../validation';
import { ModifiedText, TextSearchData } from '../types-store';
import { TextListHolder, TextListItem } from './types';
import { getTextDataId } from './get-text-data-id';

interface TextListItemsProps {
  HolderComponent: TextListHolder;
  ItemComponent: TextListItem;

  textsList: TextSearchData[];
  modifiedTexts: ModifiedText[];
  modifyText: (modifiedText: ModifiedText) => void;
  validation: { [key: string]: ValidationProps };
  translation: TextConfigurationTranslation;
}

export const TextListItems: React.FC<TextListItemsProps> = ({
  HolderComponent, ItemComponent,
  textsList, modifiedTexts, modifyText, validation, translation
}) => {

  return textsList && textsList.length > 0
    ? <HolderComponent translation={translation}>
      {textsList.map((textData, index) => {
        const previousText = index > 0 ? textsList[index - 1] : undefined;
        const modifiedText = getModifiedText(modifiedTexts, textData);
        const onModifyText = (text: string) => {
          modifyText({
            id: textData.id,
            textSet: textData?.textSet?.v ?? undefined,
            language: textData?.language?.v ?? undefined,
            text,
            onlyWhitespace: equalsIgnoringWhitespace(textData?.text, text)
          });
        };

        const componentValidation = getComponentValidation(validation, textData);
        const validationMessages: string[] =
          componentValidation.length > 0
            ? componentValidation
            : modifiedText?.text?.trim() === ''
              ? [translation.must_be_filled_out]
              : undefined;

        return <ItemComponent
          key={getTextDataId(textData)}
          textData={textData}
          previousTextData={previousText}
          modifiedText={modifiedText ? modifiedText.text : undefined}
          modifyText={onModifyText}
          edited={!!modifiedText && !modifiedText.onlyWhitespace}
          validationMessages={validationMessages}
          translation={translation}
        />;
      })}
    </HolderComponent>
    : null;
};
